import * as React from 'react'
import { cn } from '@/lib/utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border bg-white px-3 py-2 text-sm',
          'placeholder:text-neutral-400',
          'hover:border-neutral-300',
          'focus:outline-none focus:ring-2 focus:border-primary-500',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-neutral-50',
          error
            ? 'border-red-500 focus:ring-red-500'
            : 'border-neutral-200 focus:ring-primary-500',
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.displayName = 'Input'

export { Input }
export default Input